import { TileRoleRoute } from '@/types'
import { Roles } from '@/auth/azure/Roles'
import { ManagementGridFactory } from '@/routes/admin/components/ManagementGrid/ManagementGridFactory'
import { OrdersPageRoute } from '@/routes/orders/OrdersPage.route'
import { faMoneyBills } from '@fortawesome/free-solid-svg-icons'

export const OrderAdvancePaymentRoute: TileRoleRoute = {
  path: 'orderadvancepayment',
  text: 'Acconto Ordine',
  faIcon: faMoneyBills,
  element: (
    <ManagementGridFactory
      entity={'stato_acconto_ordine'}
      referencesCollection={'ordini'}
      referencesTitle={'Acconto Ordine'}
      displayField={'ded_Dis'}
      entityRoute={OrdersPageRoute.path as string}
    />
  ),
  handle: {
    crumb: () => ({
      label: 'Acconto Ordine',
      icon: faMoneyBills,
    }),
  },
  mainMenuRoute: false,
  tile: true,
  allowedRoles: [Roles.GlobalAdministrator],
}
